export default __webpack_public_path__ + "static/media/searchiconmobile.a90eb279.svg";